import { Option } from "@components/hook-form/RHFAutocomplete";

export const createVendorCompanyIdOptions = (
  source: string,
  setVendorCompanyIDOptions: React.Dispatch<React.SetStateAction<Option[]>>,
) => {
  if (!source) {
    setVendorCompanyIDOptions([]);
    return;
  }

  const values = source
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean);

  setVendorCompanyIDOptions(
    values.map((value) => ({ value, label: value })),
  );
};
